import { apiClient } from "./client";

// ---- Verifier-side ----

/** Institution officer's request inbox. Optional status filter. */
export async function listInstitutionRequests(status) {
  const res = await apiClient.get("/institution/requests", {
    params: status ? { status } : {},
  });
  return res.data;
}

/** Organisation officer's request inbox. */
export async function listOrganisationRequests(status) {
  const res = await apiClient.get("/organisation/employee-requests", {
    params: status ? { status } : {},
  });
  return res.data;
}

/** Shared: get a single verification request by id (caller must be authorized). */
/** Scoped message thread on a verification request (client requirement 3). */
export async function listRequestMessages(id) {
  const res = await apiClient.get(`/verifications/${id}/messages`);
  return res.data;
}

export async function sendRequestMessage(id, body) {
  const res = await apiClient.post(`/verifications/${id}/messages`, { body });
  return res.data;
}

export async function getVerificationRequest(id) {
  const res = await apiClient.get(`/verifications/${id}`);
  return res.data;
}

/** Approve a request. Reason optional (becomes approval note). */
export async function approveInstitutionRequest(id, reason) {
  const res = await apiClient.post(`/institution/requests/${id}/verify`, {
    reason,
  });
  return res.data;
}

/** Reject a request. Reason required. */
export async function rejectInstitutionRequest(id, reason) {
  const res = await apiClient.post(`/institution/requests/${id}/reject`, {
    reason,
  });
  return res.data;
}

export async function approveOrganisationRequest(id, reason) {
  const res = await apiClient.post(
    `/organisation/employee-requests/${id}/verify`,
    { reason },
  );
  return res.data;
}

/**
 * Organisation-only: mark a VERIFIED work credential as ended (leaver
 * close-out). endDate is YYYY-MM-DD.
 */
export async function markEmploymentEnded(id, endDate) {
  const res = await apiClient.post(
    `/organisation/employee-requests/${id}/mark-ended`,
    { endDate },
  );
  return res.data;
}

export async function rejectOrganisationRequest(id, reason) {
  const res = await apiClient.post(
    `/organisation/employee-requests/${id}/reject`,
    { reason },
  );
  return res.data;
}

// ---- Professional-side ----

/** A Professional's own verification request history. */
export async function listMyVerifications() {
  const res = await apiClient.get("/professional/verifications");
  return res.data;
}
